class McpLoopingTabs extends HTMLElement {

    static get observedAttributes() {
        return ['autoplay', 'speed'];
    }

    constructor() {
        super();

        this.tabList = this.querySelector('.js-tabs__controls');
        this.tabs = this.querySelectorAll('.js-tab__trigger');
        this.panels = this.querySelectorAll('.js-tab__panel');
        this.tabImages = this.querySelectorAll('.js-tab__image');

        this.tabshasImage = false;
        this.loop = 0;

        this.selectedPanel = this.querySelector('.js-tab__panel.tab-features__panel--display');

        this.tabList.addEventListener('click', this.handleTabChange.bind(this));

        this.tabImages.forEach(image => {
            image.addEventListener('click', this.handleImageLink.bind(this));
        })
    }

    connectedCallback() {
        if (document.querySelector('.js-tabs__images')) this.tabshasImage = true;

        if (this.hasAttribute('autoplay')) {

            const array = Array.from(this.tabs);
            let index = 0;
            let speed = 3000;

            this.getAttribute('speed') ? speed = this.getAttribute('speed') : speed;
            this.loop = setInterval(() => {
                this.deselectAllTabs();
                this.selectTab(array[index]);
                index === array.length - 1 ? index = 0 : index++;
            }, speed);
        }
    }

    disconnectedCallback() {
        clearInterval(this.loop);
        this.loop = 0;
    }

    handleTabChange(event) {
        event.preventDefault();
        //console.log('TARGET', this.tabList)
        if (!event.target.hasAttribute("href")) return;

        clearInterval(this.loop);
        this.loop = 0;
        this.deselectAllTabs();
        this.selectTab(event.target);
    }

    handleImageLink() {
        if (!this.selectedPanel.dataset.url) return;
        window.location.href = this.selectedPanel.dataset.url;
    }

    selectTab(target) {
        target.ariaSelected = true;
        let tabAttr = target.getAttribute("href");
        this.selectedPanel = this.querySelector(`${tabAttr}`)
        this.selectedPanel.classList.add('tab-features__panel--display');
        if (this.tabshasImage) {
            let selectedImage = document.querySelector(`${tabAttr.concat('-image')}`)
            document.querySelectorAll('.js-tab__image').forEach(image => {
                image.classList.add('tab__image--hidden');
            })
            selectedImage.classList.remove('tab__image--hidden');
        }
    }

    deselectAllTabs() {
        Array.from(this.tabs).map(tab => {
            tab.ariaSelected = false;
        })
        Array.from(this.panels).map(panel => {
            panel.classList.remove('tab-features__panel--display');
        })
    };
}
customElements.define('mcp-looping-tabs', McpLoopingTabs);


class McpContentDrawer extends HTMLElement {

    static get observedAttributes() {
        return ['page'];
    }

    constructor() {
        super();

        this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
        this.querySelector('#CartContent-Overlay').addEventListener('click', this.close.bind(this));
        this.setDrawerOpenerAccessibility();

        window.addEventListener("clubSubmitted", (event) => {
            this.open(event.detail);
        },
            false,
        );
    }

    setDrawerOpenerAccessibility() {
        const drawerLinks = document.querySelectorAll('.js-open-content-drawer');
        //console.log('drawerLinks', drawerLinks)
        drawerLinks.forEach(link => {
            link.setAttribute('role', 'button');
            link.setAttribute('aria-haspopup', 'dialog');
            link.addEventListener('click', (event) => {
                event.preventDefault();
                let page = '';
                event.target.getAttribute("href") ? page = event.target.getAttribute("href") : page = event.target.dataset.page;
                this.open(page);
            });
        })
    }

    open(triggeredBy) {
        //console.log("PAGE", triggeredBy)
        //console.log("PAGE 2", this)
        //if (triggeredBy) this.setActiveElement(triggeredBy);
        // here the animation doesn't seem to always get triggered. A timeout seem to help
        if (this.getAttribute('page') !== triggeredBy) return;

        setTimeout(() => {
            this.classList.add('animate', 'active');
        });
        this.addEventListener(
            'transitionend',
            () => {
                const containerToTrapFocusOn = document.getElementById('ContentDrawer');
                const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
                trapFocus(containerToTrapFocusOn, focusElement);
            },
            { once: true }
        );
        document.body.classList.add('overflow-hidden');
    }

    close() {
        this.classList.remove('active');
        removeTrapFocus(this);
        document.body.classList.remove('overflow-hidden');
    }

}
customElements.define('mcp-content-drawer', McpContentDrawer);



class McpAccordion extends HTMLElement {
    constructor() {
        super();

        this.summaries = [...this.querySelectorAll('[id^="Details-"] summary')];
        this.summaries.forEach((summary) => {
            summary.addEventListener('click', this.handleClick.bind(this))
            summary.parentElement.addEventListener('keyup', this.onKeyUpEscape.bind(this));
        });
    }

    connectedCallback() {
        this.initCollapsibles();
    }

    initCollapsibles() {
        this.summaries.forEach((summary) => {
            summary.setAttribute('role', 'button');
            summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

            if (summary.nextElementSibling.getAttribute('id')) {
                summary.setAttribute('aria-controls', summary.nextElementSibling.id);
            }
        });
    }

    handleClick(event) {
        //console.log('EVENT', event.currentTarget)
        this.closeAllCollapsible(event);
        event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    }

    closeAllCollapsible(event) {
        this.querySelectorAll(`[id^="Details-"]:not([id^=${event.currentTarget.closest('details').id}])`).forEach((detailsElement) => {
            //console.log('detailsElement', detailsElement)
            detailsElement.removeAttribute('open');
            detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
        })
    }

    onKeyUpEscape(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;

        const openDetailsElement = event.target.closest('details[open]');
        if (!openDetailsElement) return;

        const summaryElement = openDetailsElement.querySelector('summary');
        openDetailsElement.removeAttribute('open');
        summaryElement.setAttribute('aria-expanded', false);
        summaryElement.focus();
    }

}
customElements.define('mcp-accordion', McpAccordion);


function smoothScrollTo(event, offset = 0) {
    const targetId = event.target.getAttribute('href');
    const targetPosition = document.querySelector(targetId).offsetTop + offset;
    const startPosition = window.scrollY;
    const distance = targetPosition - startPosition;

    let start;
    let done = false;
    const duration = 800;

    window.requestAnimationFrame(animate);

    function animate(timeStamp) {
        if (start === undefined) {
            start = timeStamp;
        }
        const elapsed = timeStamp - start;

        //window.scrollTo(0, distance * (elapsed / duration) + startPosition)
        window.scrollTo(0, easeInOutCubic(elapsed, startPosition, distance, duration))
        if (elapsed < duration) {
            window.requestAnimationFrame(animate)
        } else {
            const scrollEnd = new CustomEvent('scrollEnd', { detail: event.target });
            dispatchEvent(scrollEnd);
        };
    }
}

function easeInOutCubic(t, b, c, d) {
    t /= d / 2;
    if (t < 1) return c / 2 * t * t * t + b;
    t -= 2;
    return c / 2 * (t * t * t + 2) + b;
}


class McpSidenav extends HTMLElement {
    constructor() {
        super();

        this.list = this.getElementsByClassName('js-sidenav__list')[0];
        this.anchors = this.list.querySelectorAll('a[href^="#"]');
        this.sections = this.getSections();
        this.scrollingSections = [...document.querySelectorAll('.anchor-content__target')];
        this.scrollingSectionsHeight = 0;

        this.clickScrolling = false;
        this.intervalID = false;
        this.expandedClass = 'dropdown--expanded';

        this.offset = 0;

        this.selectedWrapper = this.querySelector('.selected__wrapper');
        this.selected = this.querySelector('.selected__link');


        // declare Intersection Observer options
        const options = {
            root: null,
            threshold: [0, 0.1],
            rootMargin: "0px 0px -70% 0px"
        };
        // instantiate the observer
        const observer = new IntersectionObserver(
            this.handleCallback.bind(this),
            options
        );
        for (let i = 0; i < this.sections.length; i++) {
            observer.observe(this.sections[i]);
        }

        this.list.addEventListener('click', this.handleClick.bind(this))
        this.selectedWrapper.addEventListener('click', this.toggleDropdown.bind(this))
    }

    connectedCallback() {
        this.getScreenWidth();
        window.addEventListener('resize', this.getScreenWidth.bind(this));
        window.addEventListener('scrollEnd', this.handleScrollEnd.bind(this), false);
    }

    handleScrollEnd(event) {
        //console.log('scrollEnd', event.detail);
        this.resetAnchors(event.detail);
    }

    getScreenWidth() {
        if (window.innerWidth >= 1024) {
            this.isDesktop = true;
            this.offset = 0;
        } else {
            this.offset = 30;
            this.isDesktop = false;
            //this.selectedWrapper.classList.add('caret-down');
        }
    };

    toggleDropdown() {
        this.list.classList.toggle(this.expandedClass);
        this.selectedWrapper.classList.toggle('caret-down')
    };

    handleCallback(entries, observer) {
        entries.forEach((entry, index) => {
            if (!this.clickScrolling) {
                //console.log('ENTRY', entry)
                this.getVisibleSection(entry);
            }
        });
    }

    handleClick(event) {
        event.preventDefault();
        event.stopPropagation();
        let anchor = event.target.closest('a[href^="#"]');
        if (!anchor) return;
        this.toggleDropdown();
        this.clickScrolling = true;
        smoothScrollTo(event, this.offset);
    }

    getSections() {
        let sections = [];
        // get all sections with anchors
        for (let i = 0; i < this.anchors.length; i++) {
            let section = document.querySelector(this.anchors[i].getAttribute('href'));
            if (section) sections.push(section);
        }
        return sections;
    }

    getVisibleSection(entry) {
        if (this.intervalID) {
            clearInterval(this.intervalID);
        }
        let self = this;
        this.intervalID = setTimeout(function () {
            let halfWindowHeight = window.innerHeight / 2;
            let index = -1;
            for (let i = 0; i < self.sections.length; i++) {
                let top = self.sections[i].getBoundingClientRect().top;
                if (top < halfWindowHeight) index = i;
            }
            if (index > -1) {
                self.resetAnchors(self.anchors[index]);
            }
            this.intervalID = false;
        }, 100);
    }

    resetAnchors(anchor) {
        if (!anchor) return;
        this.clickScrolling = false;
        for (let i = 0; i < this.anchors.length; i++) this.anchors[i].classList.remove('sidenav__link--selected');
        anchor.classList.add('sidenav__link--selected');
        this.selected.innerHTML = anchor.innerHTML;
        this.list.classList.remove(this.expandedClass);
        this.selectedWrapper.classList.add('caret-down');
    }
}
customElements.define('mcp-sidenav', McpSidenav);



class McpReadMore extends HTMLElement {
    constructor() {
        super();

        this.description = this.querySelector('.js-description');
        this.descriptionFull = this.querySelector('.js-description-full');

        this.readmoreBtn = this.querySelector('.js-readmore');
        this.readlessBtn = this.querySelector('.js-readless');

        this.readmoreBtn.addEventListener('click', this.readMore.bind(this));
        this.readlessBtn.addEventListener('click', this.readLess.bind(this));
    }

    connectedCallback() {
        //this.initCollapsibles();
    }

    readMore(event) {
        event.preventDefault();
        this.descriptionFull.classList.remove('hidden');
        this.description.classList.add('hidden');
    }

    readLess(event) {
        event.preventDefault();
        this.descriptionFull.classList.add('hidden');
        this.description.classList.remove('hidden');
    }
}
customElements.define('mcp-read-more', McpReadMore);






